//@libs
import PropTypes from "prop-types";
//@mui-material
import { IconButton, Tooltip } from "@material-ui/core";
//import { IconButton, Tooltip } from "@mui/material";

const IconButtonBase = ({
  title = "Title",
  icon,
  size = "small",
  ...props
}) => {
  return (
    <Tooltip title={title}>
      <span>
        <IconButton size={size} {...props}>
          {icon}
        </IconButton>
      </span>
    </Tooltip>
  );
};

IconButtonBase.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
};

export default IconButtonBase;
